import { orpc } from "./rpc";

/**
 * Typed wrappers around `orpc.port.*` for the hire portal pages.
 * Pages should import from here rather than touching `orpc.port` directly,
 * so the API surface used by the portal stays grep-able in one place.
 */
export const portalRpc = orpc.port;

export type PortalErrorCode =
  | "no_active_onboarding"
  | "milestone_not_found"
  | "resource_not_found"
  | "todo_not_found"
  | "tool_setup_not_found"
  | "onboarding_terminal"
  | "owner_unreachable"
  | "already_configured"
  | "already_submitted"
  | "not_yet_open"
  | "survey_closed"
  | "invalid_score"
  | "comment_too_long"
  | "item_index_out_of_range"
  | "tool_index_out_of_range";

export function extractPortalErrorCode(error: unknown): PortalErrorCode | null {
  if (typeof error !== "object" || error === null) return null;
  const data = (error as { data?: unknown }).data;
  if (typeof data !== "object" || data === null) return null;
  const code = (data as { code?: unknown }).code;
  return typeof code === "string" ? (code as PortalErrorCode) : null;
}
